<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-row>
          <b-col lg="6" sm="12">
            <b-form-group id="group-name" label-for="input-name">
              <template v-slot:label>
                CheckList Name
                <span class="text-danger">*</span>
              </template>

              <b-form-input
                id="input-name"
                type="text"
                v-model="form.name"
                placeholder="Enter CheckList Name"
                :class="{
                  'box-shadow3 bg-light text-dark': !isDarkMode,
                  'bg-dark text-light placeholder-light': isDarkMode
                }"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
              ></b-form-input>

              <b-form-invalid-feedback id="input-name-invalid">Please enter checklist name.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-product" label-for="input-product">
              <template v-slot:label>
                Active
                <span class="text-danger">*</span>
              </template>

              <multiselect
                id="input-status"
                placeholder="Select Active Type"
                v-model="form.active"
                :options="['True', 'False']"
                :class="{
                  'box-shadow3': !isDarkMode,
                  darkMode: isDarkMode
                }"
              ></multiselect>

              <b-form-invalid-feedback id="input-status-invalid"
                >Please select valid active type.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Select Date
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="start-datepicker"
                        placeholder="Start Date"
                        :min="minDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.startDate"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="example-input"
                      v-model="form.startDate"
                      type="text"
                      placeholder="Start Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col>
                  <b-input-group class="box-shadow2 mb-2">
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        id="end-datepicker"
                        placeholder="End Date"
                        :min="minDate"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="form.endDate"
                        class="box-shadow3"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-input
                      id="example-input"
                      v-model="form.endDate"
                      type="text"
                      placeholder="End Date"
                      autocomplete="off"
                      :class="{
                        '': !isDarkMode,
                        'bg-dark text-light placeholder-light': isDarkMode
                      }"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-frequency" label-for="input-frequency">
              <template v-slot:label> Frequency </template>

              <multiselect
                id="input-frequency"
                :options="['ONE-TIME', 'ANYTIME', 'DAILY', 'WEEKLY', 'BIWEEKLY', 'MONTHLY', 'HALF-YEARLY', 'YEARLY']"
                v-model="form.frequency"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
                placeholder="How Frequently report need to be submitted."
              ></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" sm="12">
            <b-form-group id="group-name" label-for="input-name">
              <template v-if="formType === 'new'" v-slot:label>
                Set Time limit
                <span class="text-danger">*</span>
              </template>
              <template v-else v-slot:label>
                Update Time limit
                <span class="text-danger">*</span>
              </template>
              <div>
                <b-form-timepicker
                  v-model="form.activeTillTime"
                  :class="{
                    'box-shadow3': !isDarkMode,
                    'bg-dark text-light placeholder-light': isDarkMode
                  }"
                  id="timepicker-buttons"
                  now-button
                  label-now-button="Select Current Time"
                  reset-button
                  label-close-button="select"
                  locale="en"
                ></b-form-timepicker>
              </div> </b-form-group
          ></b-col>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Store Format
                <span class="text-danger">*</span>
              </template>

              <multiselect
                ref="multiselect"
                tag-placeholder="Add this as new tag"
                track-by="value"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                v-model="form.formats"
                placeholder="Select Store Format"
                label="text"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
                :options="formats"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" sm="12">
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Region Ids
                <span class="text-danger">*</span>
              </template>

              <multiselect
                ref="multiselect"
                tag-placeholder="Add this as new tag"
                track-by="value"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                v-model="regionids"
                placeholder="Select region Ids"
                label="text"
                :options="regions"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Cluster Ids
                <span class="text-danger">*</span>
              </template>
              <multiselect
                ref="multiselect"
                tag-placeholder="Add this as new tag"
                track-by="value"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                v-model="clusterids"
                placeholder="Select Cluster Ids"
                label="text"
                :options="clusters"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
              >
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Store Ids
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col sm="12" lg="12">
                  <multiselect
                    v-model="storeids"
                    ref="multiselect"
                    tag-placeholder="Add this as new tag"
                    placeholder="Select Store Ids"
                    label="text"
                    track-by="value"
                    :options="stores"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTag"
                    :class="{
                      'box-shadow3 bg-light text': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                  ></multiselect>
                </b-col>
                <b-col>
                  <b-button
                    class="box-shadow3"
                    @click="uploadStores"
                    :variant="isDarkMode ? 'outline-success' : 'success'"
                    ><font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />Upload Stores</b-button
                  >
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" sm="12">
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Category
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col lg="12" sm="12">
                  <multiselect
                    v-model="categories"
                    ref="multiselect"
                    tag-placeholder="Add this as new tag"
                    placeholder="Select Category"
                    label="text"
                    track-by="value"
                    :options="categories"
                    :multiple="true"
                    :taggable="true"
                    @tag="addCategoryTag"
                    :class="{
                      'box-shadow3 bg-light text': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                  ></multiselect>
                </b-col>
                <b-col>
                  <b-button @click="uploadCategories" :variant="isDarkMode ? 'outline-success' : 'success'"
                    ><font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />Upload Categories</b-button
                  >
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Department
                <span class="text-danger">*</span>
              </template>
              <b-row>
                <b-col sm="12" lg="12">
                  <multiselect
                    v-model="departments"
                    ref="multiselect"
                    tag-placeholder="Add this as new tag"
                    placeholder="Select Department"
                    label="text"
                    track-by="value"
                    :options="departments"
                    :multiple="true"
                    :taggable="true"
                    @tag="addDepartmentTag"
                    :class="{
                      'box-shadow3 bg-light text': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                  ></multiselect>
                </b-col>
                <b-col>
                  <b-button @click="uploadDepartment" :variant="isDarkMode ? 'outline-success' : 'success'"
                    ><font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />Upload Departments</b-button
                  >
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group id="group-products" label-for="input-products">
              <template v-slot:label>
                Role
                <span class="text-danger">*</span>
              </template>

              <multiselect
                id="input-role"
                v-model="form.roles"
                placeholder="Select role"
                label="text"
                ref="multiselect"
                track-by="value"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                :options="role"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
              ></multiselect>
            </b-form-group>
          </b-col>
        </b-row>

        <!--           <b-form-group id="group-role" label-for="input-role" disabled>
<template v-slot:label>
              Permission
              <span class="text-danger">*</span>
            </template>

            <multiselect
              id="input-permission"
              v-if="isVisible"
              v-model="form.permission"
              placeholder="Select Permission"
              label="text"
              :options="permission"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
            ></multiselect>
          </b-form-group>
        </b-form-group> -->

        <!--         <b-form-group id="group-role" label-for="input-role" disabled>
<template v-slot:label>
            Notify To
            <span class="text-danger">*</span>
          </template>

          <multiselect
            ref="multiselect"
            v-if="isVisible"
            tag-placeholder="Add this as new tag"
            track-by="value"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            id="input-role-help"
            v-model="notifyTo"
            placeholder="Select Nofity To "
            label="text"
            :options="role"
                :class="{
                  'box-shadow3 bg-light text': !isDarkMode,
                  darkMode: isDarkMode
                }"
          >
          </multiselect>
        </b-form-group> -->

        <!-- <div class="input wrapper items-center" v-for="(input, email) in emails" :key="email">
          <b-row class="mb-3">
            <b-col>
              <b-row>
                <b-col cols="4">
                  <template labelfor="input-category"> Share To </template>
                  <b-form-input
                    id="input-email"
                    v-model="input.email"
                    placeholder="Enter Email Address"
                    type="email"
                    aria-describedby="input-live-help input-live-feedback"
                    value="ok"
                  ></b-form-input>
                </b-col>

                <b-col sm="0">
                  <b-button
                    class="mt-4"
                    @click="removeEmail(email)"
                    v-show="email || (!email && emails.length > 1)"
                    variant="danger"
                    >Delete</b-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-button @click="addEmail(email)" v-show="email == emails.length - 1" variant="primary"><font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />Add</b-button>
        </div>
        <b-col cols="0" class="mb-3">
          <div class="upload">
            <b-button variant="success" @click="uploadEmail"><font-awesome-icon :icon="['fas', 'upload']" class="mr-1" /><font-awesome-icon :icon="['fas', 'upload']" class="mr-1" /> Upload Emails</b-button>
          </div>
        </b-col>-->

        <!-- <template v-if="storeIdError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ storeIdError }}</b-col>
          </b-row>
        </template> -->
        <h1 class="page-title text-center">Checkpoints</h1>
        <div class="input wrapper items-center" v-for="(input, checkpoint) in inputs" :key="checkpoint">
          <b-row
            class="mb-3 border-bottom pb-2"
            :class="{
              addColor: editedCheckpoints.includes(input)
            }"
          >
            <b-col>
              <b-row>
                <b-col sm="12" lg="3" class="mt-3">
                  <template labelfor="input-serial"> Serial Number </template>
                  <b-form-input
                    id="input-serial"
                    placeholder="Enter number"
                    v-model="input.serialNumber"
                    type="text"
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                  ></b-form-input>
                </b-col>
                <b-col sm="12" lg="3" class="mt-3">
                  <template labelfor="input-category">Category </template>
                  <multiselect
                    id="input-category"
                    placeholder="Set Category"
                    v-model="input.category"
                    :class="{
                      'box-shadow3': !isDarkMode,
                      darkMode: isDarkMode
                    }"
                    :options="categories.map(item => item.value)"
                  ></multiselect>
                </b-col>
                <b-col sm="12" lg="3" class="mt-3">
                  <template labelfor="input-question"> Question </template>
                  <b-form-textarea
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    id="input-question"
                    v-model="input.questionText"
                    type="text"
                    placeholder="Enter question"
                  ></b-form-textarea>
                </b-col>
                <b-col sm="12" lg="3" class="mt-3">
                  <template labelfor="input-question"> Weightage </template>
                  <b-form-input
                    id="input-weightage"
                    v-model="input.weightAge"
                    type="number"
                    step="0.01"
                    :class="{
                      'box-shadow3 bg-light text-dark': !isDarkMode,
                      'bg-dark text-light placeholder-light': isDarkMode
                    }"
                    placeholder="Enter weightage"
                  ></b-form-input>
                </b-col>
                <!-- <b-col>
                    <template labelfor="input-image">Img Mandatory </template>

                    <multiselect id="input-image" placeholder="Set Image Mandatory" v-model="input.imageMandatory"
                      :options="viewType"></multiselect>
                  </b-col>-->
              </b-row>
              <b-row class="mt-2">
                <b-col sm="12" lg="4">
                  <b-row>
                    <b-col>
                      <b-button
                        class="box-shadow2"
                        @click="update(checkpoint, input)"
                        v-show="checkpoint || (!checkpoint && inputs.length > 1)"
                        :variant="isDarkMode ? 'outline-success' : 'success'"
                        ><font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save Checkpoint</b-button
                      >
                      <b-button
                        class="ml-1 box-shadow2"
                        @click="remove(checkpoint, input._id)"
                        v-show="checkpoint || (!checkpoint && inputs.length > 1)"
                        :variant="isDarkMode ? 'outline-danger' : 'danger'"
                        ><font-awesome-icon :icon="['fas', 'trash']" class="mr-1" />Delete</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-button
            class="box-shadow2"
            @click="add(checkpoint)"
            v-show="checkpoint == inputs.length - 1"
            :variant="isDarkMode ? 'outline-primary' : 'primary'"
            ><font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />Add CheckPoints</b-button
          >
        </div>
        <div class="upload mt-2">
          <b-button class="box-shadow2" :variant="isDarkMode ? 'outline-success' : 'success'" @click="showUpload"
            ><font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />Upload Checkpoints</b-button
          >
        </div>

        <b-row class="mt-5">
          <b-col sm="12" class="text-right">
            <b-button
              type="submit"
              size="sm"
              :variant="isDarkMode ? 'outline-success' : 'success'"
              :disabled="loading"
              class="box-shadow2"
            >
              <span class="spinner spinner-white" v-if="loading"></span>
              <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save Checklist
            </b-button>
            <b-button
              class="ml-2 box-shadow2"
              size="sm"
              :variant="isDarkMode ? 'outline-warning' : 'warning'"
              :to="{ path: `/checklistV2` }"
            >
              <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import csv from 'csvtojson';
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import _ from 'lodash';
import { ChecklistV2 } from '@/model/checklistV2';
import configService from '@/services/configService';
import router from '@/router';
import Multiselect from 'vue-multiselect';

const init = {
  mounted: el => el.init()
};

export default {
  name: 'CheckListFormBox',
  directives: {
    init
  },
  components: {
    Multiselect
  },
  props: {
    listUrl: String,
    formType: String,
    checklistType: String,
    checkpointTitle: String
    // isCheckpointEdit: Boolean
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      emails: [
        {
          email: ''
        }
      ],
      inputs: [{ serialNumber: '', category: '', questionText: '', weightAge: '' }],
      title: '',
      email: [],
      formLoaded: true,
      isVisible: false,
      checkpointsDeleted: [],
      editedCheckpoints: [],
      regions: [],
      clusters: [],
      formats: [],
      stores: [],
      categories: [],
      departments: [],
      role: [],
      Permission: [],
      storeids: [],
      clusterids: [],
      checkpoints: [],
      regionids: [],
      notifyTo: [],
      form: {
        name: null,
        active: 'True',
        startDate: null,
        endDate: null,
        storeids: [],
        regionids: [],
        formats: [],
        email: [],
        notifyTo: [],
        clusterids: [],
        Permission: [],
        roles: [],
        checkpoints: [],
        frequency: 'ONE-TIME',
        activeTillTime: null
      },
      storeIdError: null,
      clusterIdError: null,
      regionIdError: null,
      dateTimeFormat: configService.get('format').pickerDateTime,
      minDate: moment().format('YYYY-MM-DD'),
      checklistEnabled: _.reduce(
        ChecklistV2.checklistEnabled,
        (result, value, key) => {
          result.push({ value, text: _.capitalize(key) });
          return result;
        },
        []
      ),
      viewType: ['true', 'false']
    };
  },
  validations() {
    const formValidation = {
      name: {
        required
      },
      active: {
        required
      }
    };

    if (this.formType === 'new') {
      formValidation.name.required = required;
      formValidation.active.required = required;
    }

    return { form: formValidation };
  },
  mounted() {
    this.listRole({ router });
    this.listStore({ router });
    this.listCluster({ router, query: { type: 'cluster' } });
    this.listRegion({ router, query: { type: 'region' } });
    this.listFormat({ router, query: { type: 'format' } });

    this.$nextTick(async () => {
      if (this.formType === 'new') {
        if (this.checklistType === 'checklistV2') {
          this.form.id = ChecklistV2.checklist._id; // eslint-disable-line
        }
        this.form.status = ChecklistV2.checklistEnabled.active;
        this.formLoaded = false;
        this.$v.$touch(); // Set initial validation
        this.$v.$reset(); // Reset $dirty
      }
    });
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new checklist' : 'Update checklist';
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('role', ['roles']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('checklistV2', ['loading', 'checklistV2']),
    ...mapState('store', ['storeList', 'regionList', 'clusterList', 'formatList'])
  },
  methods: {
    ...mapActions('role', ['listRole']),
    ...mapActions('report', ['upload']),
    ...mapActions('checklistV2', ['list', 'getOne', 'postOne']),
    ...mapActions('store', ['listStore', 'listRegion', 'listCluster', 'listFormat']),
    createCsvForCheckpoints() {
      const csv = `Serial Number, category,questionText,weightAge\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'Checkpoint.csv';
      anchor.click();
    },

    async showUpload() {
      await Vue.swal({
        title: 'Upload Checkpoints',
        text: 'Please select the file to upload',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your Checkpoint file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createCsvForCheckpoints();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const inputs = csvRow.slice(1, csvRow.length).map(item => {
                  if (item[3] != '') {
                    item[3] = parseFloat(item[3]);
                  }
                  if (item[3] === '') {
                    item[3] = null;
                  }
                  return {
                    serialNumber: item[0],
                    category: item[1].toUpperCase(),
                    questionText: item[2],
                    weightAge: item[3]
                  };
                });
                const uploadingCategories = inputs.map(item => item.category.toUpperCase());
                const categoryArray = this.categories.map(item => item.value);
                const xyx = uploadingCategories.every(item => categoryArray.includes(item));
                if (xyx === true) {
                  this.inputs.push(inputs);
                  this.inputs = this.inputs.flat();
                } else {
                  Vue.swal({
                    title: 'Categories do not match',
                    text: 'Please make sure that all categories which you are trying to upload are present in category section',
                    icon: 'error',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },
    createCsvEmail() {
      const csv = `Email\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleFile.csv';
      anchor.click();
    },
    async uploadEmail() {
      await Vue.swal({
        title: 'Upload file for emails..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your email file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createCsvEmail();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const emails = csvRow.slice(1, csvRow.length).map(item => {
                  if (!item[0].includes('@rpsg.in')) {
                    Vue.swal({
                      title: 'Invalid email',
                      text: `${item[0]} is not a valid email, please use only rpsg.in emails`,
                      icon: 'error',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                  } else {
                    return {
                      email: item[0]
                    };
                  }
                });
                this.emails = emails;
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },
    createCsv() {
      const csv = `Store Id\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleFile.csv';
      anchor.click();
    },
    async uploadStores() {
      await Vue.swal({
        title: 'Upload file for Stores..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your Store file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createCsv();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const inputs = csvRow.slice(1, csvRow.length).map(item => {
                  if (item[0].length !== 4) {
                    Vue.swal({
                      title: 'Access Denied',
                      text: `Store Id ${item[0].charAt(0).toUpperCase() + item[0].slice(1)} must be 4 digits`,
                      type: 'error',
                      confirmButtonText: 'Ok',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                    return null;
                  }
                  const inUppercase = item[0].toUpperCase();
                  const compareStoreIdFromDatabse = this.newStoreList.filter(store => store.storeid === inUppercase);
                  if (compareStoreIdFromDatabse.length === 0) {
                    Vue.swal({
                      title: 'Access Denied',
                      text: `Store id ${
                        item[0].charAt(0).toUpperCase() + item[0].slice(1)
                      } is not found in database! Please enter correct store id.`,
                      type: 'error',
                      confirmButtonText: 'Ok',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                    return null;
                  }
                  return {
                    value: item[0].charAt(0).toUpperCase() + item[0].slice(1),
                    text: item[0].charAt(0).toUpperCase() + item[0].slice(1)
                  };
                });
                const uniqueStoreId = new Set(inputs.map(input => input.value));
                const getDuplicateValue = [...uniqueStoreId].filter(
                  item => inputs.filter(input => input.value === item).length > 1
                );
                if (getDuplicateValue.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Store id ${getDuplicateValue[0]} is duplicate in sample file!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.abc = inputs.map(store => ({
                  value: store.value,
                  text: store.value
                }));
                const newAddingStore = this.abc.map(store => store.value);
                const foundExistStore = this.storeids.filter(store => newAddingStore.includes(store.value));
                if (foundExistStore.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Store id ${foundExistStore[0].value} is already there!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.storeids = [...this.storeids, ...this.abc];
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },
    createCategoryCsv() {
      const csv = `Category\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleCategoryFile.csv';
      anchor.click();
    },
    async uploadCategories() {
      await Vue.swal({
        title: 'Upload file for Categories..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your categories file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createCategoryCsv();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const inputs = csvRow
                  .slice(1, csvRow.length)
                  .map(item => {
                    return {
                      value: item[0].toUpperCase(),
                      text: item[0].toUpperCase()
                    };
                  })
                  .filter(item => item.value.trim() !== '');

                const uniqueCategories = new Set(inputs.map(input => input.value));
                const getDuplicateValue = [...uniqueCategories].filter(
                  item => inputs.filter(input => input.value === item).length > 1
                );
                if (getDuplicateValue.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Category: ${getDuplicateValue[0]} is duplicate in sample file!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.abc = inputs.map(category => ({
                  value: category.value,
                  text: category.value
                }));
                const newAddingCategory = this.abc.map(category => category.value);
                const foundExistCategory = this.categories.filter(category =>
                  newAddingCategory.includes(category.value)
                );
                if (foundExistCategory.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Category: ${foundExistCategory[0].value} is already there!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.categories = [...this.categories, ...this.abc];
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },
    createDepartmentCsv() {
      const csv = `Department\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleDepartmentFile.csv';
      anchor.click();
    },
    async uploadDepartment() {
      await Vue.swal({
        title: 'Upload file for Departments..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your Departments file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createDepartmentCsv();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const inputs = csvRow
                  .slice(1, csvRow.length)
                  .map(item => {
                    return {
                      value: item[0].toUpperCase(),
                      text: item[0].toUpperCase()
                    };
                  })
                  .filter(item => item.value.trim() !== '');
                const uniqueDepartments = new Set(inputs.map(input => input.value));
                const getDuplicateValue = [...uniqueDepartments].filter(
                  item => inputs.filter(input => input.value === item).length > 1
                );
                if (getDuplicateValue.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Department: ${getDuplicateValue[0]} is duplicate in sample file!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.abc = inputs.map(department => ({
                  value: department.value,
                  text: department.value
                }));
                const newAddingDepartment = this.abc.map(department => department.value);
                const foundExistDepartment = this.departments.filter(department =>
                  newAddingDepartment.includes(department.value)
                );
                if (foundExistDepartment.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Department: ${foundExistDepartment[0].value} is already there!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.departments = [...this.departments, ...this.abc];
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },
    onSubmit() {
      this.storeIdError = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      const storeids = [];
      this.storeids.map(({ value }) => storeids.push(value));

      const categories = [];
      this.categories.map(({ value }) => categories.push(value));

      const departments = [];
      this.departments.map(({ value }) => departments.push(value));

      const regions = [];
      this.regionids.map(({ value }) => regions.push(value));

      const clusters = [];
      this.clusterids.map(({ value }) => clusters.push(value));

      const formats = [];
      this.form.formats.map(({ value }) => formats.push(value));

      const role = [];
      const notifyTo = role;
      this.notifyTo.map(({ value }) => role.push(value));

      const roles = [];
      this.form.roles.map(({ value }) => roles.push(value));

      const checkpointsAdded = this.inputs
        .filter(({ _id }) => !_id)
        .map(j => ({ ...j, imageMandatory: j.imageMandatory === 'true' }));
      const checklistV2 = {
        name: this.form.name,
        active: this.form.active === 'True',
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        frequency: this.form.frequency,
        permissions: this.form.permission ? this.form.permission : [],
        storeids,
        categories,
        departments,
        roles: roles || [],
        clusters: clusters || [],
        notifyTo: notifyTo || [],
        regions: regions || [],
        formats: formats || [],
        checkpoints: this.inputs,
        checkpointsDeleted: this.checkpointsDeleted,
        checkpointsAdded: checkpointsAdded || [],
        editedCheckpoints: this.editedCheckpoints,
        shareTo: this.emails.map(i => i.email) || [],
        activeTillTime: this.form.activeTillTime ? `${moment().format('YYYY-MM-DD')}T${this.form.activeTillTime}` : null
      };
      for (let i = 0; i < checklistV2.shareTo.length; i++) {
        if (_.isEmpty(checklistV2.shareTo[i]) === true) {
          if (this.formType === 'new') {
            this.$emit('add', { checklistV2 });
          } else {
            this.$emit('edit', { checklistV2 });
          }
          return false;
        }
        if (!checklistV2.shareTo[i].includes('@rpsg.in')) {
          Vue.swal({
            title: 'Access Denied',
            text: `${checklistV2.shareTo[i]} is not a valid email address! Please use only rpsg.in email address.`,
            type: 'error',
            confirmButtonText: 'Ok',
            background: this.isDarkMode ? '#464d54' : '#ffffff',
            customClass: {
              title: this.isDarkMode ? 'text-light' : 'text-dark',
              content: this.isDarkMode ? 'text-light' : 'text-dark'
            }
          });
          return false;
        }
        if (!checklistV2.checkpoints.length >= 1) {
          Vue.swal({
            title: 'Access Denied',
            text: `you are required to add at least on checkpoint`,
            type: 'error',
            confirmButtonText: 'Ok',
            background: this.isDarkMode ? '#464d54' : '#ffffff',
            customClass: {
              title: this.isDarkMode ? 'text-light' : 'text-dark',
              content: this.isDarkMode ? 'text-light' : 'text-dark'
            }
          });
          return false;
        }
      }
      if (this.formType === 'new') {
        this.$emit('add', { checklistV2 });
      } else {
        this.$emit('edit', { checklistV2 });
      }
      return false;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
      setTimeout(() => {
        this.$refs.multiselect.$refs.search.focus();
      }, 100);
    },
    addCategoryTag(newTag) {
      this.categories.push({ text: newTag, value: newTag });
    },
    addDepartmentTag(newTag) {
      this.departments.push({ text: newTag, value: newTag });
    },
    add() {
      this.inputs.push({ serialNumber: '', category: [], questionText: '', weightAge: '' });
    },
    update(index, checkpoint) {
      if (checkpoint._id) {
        this.editedCheckpoints.push(checkpoint);
      }
    },
    remove(index, checkpointId) {
      Vue.swal({
        title: 'Are you sure you want to delete this checkpoint ?',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.dismissed) {
          return null;
        }
        if (result.value) {
          if (checkpointId) {
            this.checkpointsDeleted.push(checkpointId);
          }
          this.inputs.splice(index, 1);
        }
      });
    },
    addEmail() {
      this.emails.push({ email: '' });
    },
    removeEmail(index) {
      this.emails.splice(index, 1);
    }
  },
  watch: {
    checklistV2(newValue) {
      if (!this.checklistV2.id) {
        return;
      }
      // Loaded checklist, assign to form
      this.form.name = newValue.name;
      this.form.active = newValue.active;
      this.form.checkpointType = newValue.checkpointType;
      this.form.startDate = moment(newValue.startDate).format('YYYY-MM-DD');
      this.form.endDate = moment(newValue.endDate).format('YYYY-MM-DD');
      this.form.frequency = newValue.frequency;
      this.inputs = newValue.checkpoints;
      this.emails = newValue.shareTo.map(email => ({ email }));
      this.storeids = newValue.storeids.map(store => ({ text: store, value: store }));
      this.categories = newValue.categories.map(category => ({ text: category, value: category }));
      this.departments = newValue.departments.map(department => ({ text: department, value: department }));
      this.regionids = newValue.regions.map(region => ({ text: region, value: region }));
      this.notifyTo = newValue.notifyTo.map(({ name, _id }) => ({ text: name, value: _id }));
      this.clusterids = newValue.clusters.map(cluster => ({ text: cluster, value: cluster }));
      this.form.roles = newValue.roles.map(({ name, _id }) => ({ text: name, value: _id }));
      this.form.formats = newValue.formats.map(format => ({ text: format, value: format }));
      this.form.activeTillTime = newValue.activeTillTime ? moment(newValue.activeTillTime).format('HH:mm:ss') : null;

      const foundNotify = this.notifyTo.find(i => i.value === newValue.roles[0]);
      if (foundNotify) {
        this.form.notifyTo = foundNotify;
      } else {
        this.form.notifyTo = { text: newValue.roles[0], value: newValue.roles[0] };
      }
      this.formLoaded = true;
      this.$v.$touch(); // Set initial validation
      this.$v.$reset(); // Reset $dirty
    },
    clusterList(newValue) {
      this.clusters = newValue;
    },
    regionList(newValue) {
      this.regions = newValue;
    },
    formatList(newValue) {
      this.formats = newValue;
    },
    roles(newValue) {
      this.role = newValue;
    },
    storeList(newValue) {
      let comparingStores = [];
      comparingStores = newValue.map(store => ({
        storeid: store.storeid
      }));
      this.newStoreList = comparingStores;
      this.stores = newValue.map(store => ({ text: store.storeid, value: store.storeid }));
    },
    categories(newCategories) {
      const currentCategoriesSet = new Set(newCategories.map(item => item.value));
      this.inputs = this.inputs.filter(input => currentCategoriesSet.has(input.category));
      if (this.inputs.length === 0) {
        this.inputs.push({ serialNumber: '', category: [], questionText: '', weightAge: '' });
      }
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.addColor {
  background: rgb(224, 224, 224);
  border-radius: 8px;
}

.calender {
  display: flex;
  width: auto;
  margin-left: -9px;
  margin-bottom: 0.7rem;
}

.upload {
  margin-top: 8px;
}
</style>
